import Vue from 'vue'
import store from '@/store';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Notifications from '../views/Notifications.vue';
import QPlusHome from '../views/qplus/Home';
import QPlusNotifications from '../views/qplus/Notifications';
import Settings from '../views/Settings.vue';
import AppUpdate from '../views/AppUpdate.vue';
import AppAlerts from '../views/AppAlerts.vue';
import Deeplinks from "../views/Deeplinks.vue";
import CreateDeeplink from "../views/CreateDeeplink.vue";
import SchoolStatuses from '@/views/SchoolStatuses.vue';
import NotificationDetails from "@/views/NotificationDetails";
import NotificationApproval from "@/views/NotificationApproval";
import Error from '@/views/Error';
import {ROLES} from "@/static/data";

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'base',
    beforeEnter: (to, from, next) => {
      const lastSelectedApp = localStorage.getItem('lastSelectedApp');
      if (!lastSelectedApp) {
        next();
        return;
      }
      if (lastSelectedApp === 'staffPortalApp') {
        next("/notifications");
        return;
      }
      if (lastSelectedApp === 'NSWSchoolsUpdateApp') {
        next("/schoolstatuses");
        return;
      }
      if (lastSelectedApp === 'qPlusApp') {
        next("/qplus/notifications");
      }
    }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: Home,
    beforeEnter: (to, from, next) => {
      const profile = router.app.$OAuth.data.profile;
      
      if (!profile || !profile.acl || !((Array.isArray(profile.acl) && profile.acl.some(acl => acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) || profile.acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) {
        store.commit('setErrorMessage', "<p>You don't have permission to access this page.</p>");
        next({name: 'error'});
        return;
      }
      localStorage.setItem('lastSelectedApp', 'staffPortalApp');
      next();
    },
  },
  {
    path: '/notifications/create',
    name: 'createNotifications',
    component: Notifications,
    beforeEnter: (to, from, next) => {
      const profile = router.app.$OAuth.data.profile;
      if (!profile || !profile.acl || !((Array.isArray(profile.acl) && profile.acl.some(acl => acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) || profile.acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) {
        store.commit('setErrorMessage', "<p>You don't have permission to access this page.</p>");
        next({name: 'error'});
        return;
      }
      store.commit('setCreateMode', true);
      next();
    }
  },
  {
    path: '/notifications/:id',
    name: 'notificationDetails',
    component: NotificationDetails,
    beforeEnter: (to, from, next) => {
      const profile = router.app.$OAuth.data.profile;
      if (!profile || !profile.acl || !((Array.isArray(profile.acl) && profile.acl.some(acl => acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) || profile.acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) {
        store.commit('setErrorMessage', "<p>You don't have permission to access this page.</p>");
        next({name: 'error'});
        return;
      }
      if (!to.params.id || isNaN(to.params.id)) {
        next({name: 'wrong-path'});
        return;
      }
      store.dispatch('fetchNotification', to.params.id)
        .then(() => {
          if (!store.getters.currentNotification) {
            store.commit('setErrorMessage', "<p>It was not possible to find the notification with the informed ID.</p>");
            next({name: 'error'});
          } else if (store.getters.currentNotification.status === 'Draft') {
            store.commit("setCreateMode", true);
            next({name: store.getters.currentNotification.appName === 'qplus' ? 'qPlusCreateNotifications' : 'createNotifications'});
          } else {
            store.commit('setDetailsMode', true);
            next();
          }
        })
        .catch(err => {
          if (err.response) {
            err = `<p>${err}</p><p>Description: ${err.response.data.errMsg}</p>`
          } else {
            err = `<p>${err}.</p>`
          }
          store.commit('setErrorMessage', err);
          next({name: 'error'});
        });
    }
  },
  {
    path: '/error',
    name: 'error',
    component: Error
  },
  {
    path: '/notifications/approval/:id',
    name: 'approveNotification',
    component: NotificationApproval,
    beforeEnter(to, from, next) {
      const profile = router.app.$OAuth.data.profile;
      if (!profile || !profile.acl || !((Array.isArray(profile.acl) && profile.acl.some(acl => acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) || profile.acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) {
        store.commit('setErrorMessage', "<p>You don't have permission to access this page.</p>");
        next({name: 'error'});
        return;
      }
      if (!to.params.id || isNaN(to.params.id)) {
        next({name: 'wrong-path'});
        return;
      }
      store.dispatch('fetchNotification', to.params.id)
        .then(() => {
          const notification = store.getters.currentNotification;
          if (notification && notification.status === 'Pending') {
            store.dispatch('fetchApprovers')
              .then(() => {
                const approver = store.getters.approvers.find(approver => approver.emailAddress.toLowerCase() === notification.approverEmail.toLowerCase());
                const userId = router.app.$OAuth.data.profile.username;
                if (approver?.userId.toLowerCase() === userId.toLowerCase()) {
                  next();
                } else {
                  store.commit('setErrorMessage', "<p>You don't have permission to access this page.</p>");
                  next({name: 'error'});
                }
              })
              .catch(() => {
                store.commit('setErrorMessage', "<p>It was not possible to check if you have permission to access this page.</p>");
                router.push({name: 'error'});
              })
          } else {
            store.commit('setErrorMessage', "<p>It was not possible to find the notification with the informed ID or the notification was already reviewed.</p>");
            next({name: 'error'});
          }
        })
        .catch(err => {
          if (err.response && err.response.data.errMsg) {
            err = `<p>${err}</p>
                   <p>Description: ${err.response.data.errMsg}</p>`
          } else {
            err = `<p>${err}.</p>`
          }
          store.commit('setErrorMessage', err);
          router.push({name: 'error'});
        });
    }
  },
  {
    path: '/deeplinks',
    name: 'deeplinks',
    component: Deeplinks
  },
  {
    path: '/deeplinks/create',
    name: 'create-deeplink',
    component: CreateDeeplink
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings
  },
  {
    path: '/app-alerts',
    name: 'app-alerts',
    component: AppAlerts
  },
  {
    path: '/app-updates',
    name: 'app-updates',
    component: AppUpdate
  },
  {
    path: '/schoolstatuses',
    name: 'schoolstatuses',
    component: SchoolStatuses,
  },
  {
    path: '/qplus/notifications',
    name: 'qPlusNotifications',
    component: QPlusHome,
    beforeEnter: (to, from, next) => {
      const profile = router.app.$OAuth.data.profile;
      if (!profile || !profile.acl || !((Array.isArray(profile.acl) && profile.acl.some(acl => acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) || profile.acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) {
        store.commit('setErrorMessage', "<p>You don't have permission to access this page.</p>");
        next({name: 'error'});
        return;
      }
      localStorage.setItem('lastSelectedApp', 'qPlusApp');
      next();
    },
  },
  {
    path: '/qplus/notifications/create',
    name: 'qPlusCreateNotifications',
    component: QPlusNotifications,
    beforeEnter: (to, from, next) => {
      const profile = router.app.$OAuth.data.profile;
      if (!profile || !profile.acl || !((Array.isArray(profile.acl) && profile.acl.some(acl => acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) || profile.acl.toLowerCase() === ROLES.WEB_NOTIFICATION.toLowerCase())) {
        store.commit('setErrorMessage', "<p>You don't have permission to access this page.</p>");
        next({name: 'error'});
        return;
      }
      store.commit('setCreateMode', true);
      next();
    }
  },
  {
    path: '*',
    name: 'wrong-path',
    component: Error,
    beforeEnter(to, from, next) {
      store.commit('setErrorMessage', "<p>Sorry, this page doesn't seem to exist.</p>");
      next();
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
